import { splitLines } from '../detect.js';
const TRANSITION_RE = /^\s*(\S+)\s*-->\s*(\S+)\s*(?::\s*(.+))?\s*$/;
const STATE_DECL_RE = /^\s*state\s+(\S+)\s*(?:<<[^>]+>>)?\s*(?::\s*(.+))?\s*$/;
const FORK_HISTORY = /^\s*(?:fork|join|choice)\s+(\S+)\s*$/;
export const parseStateDiagram = (source) => {
    const lines = splitLines(source);
    const nodes = new Map();
    const edges = [];
    const stack = [];
    const ensure = (id, label, shape = 'ellipse') => {
        if (!nodes.has(id)) {
            nodes.set(id, { id, label: label ?? id, shape, parent: stack[stack.length - 1] });
        }
    };
    for (const raw of lines) {
        const line = raw.trim();
        if (!line || /^stateDiagram/i.test(line))
            continue;
        if (line.startsWith('state ')) {
            const m = STATE_DECL_RE.exec(line);
            if (m) {
                ensure(m[1], m[2], 'ellipse');
                continue;
            }
        }
        const fork = FORK_HISTORY.exec(line);
        if (fork) {
            ensure(fork[1], fork[1], 'rect');
            continue;
        }
        if (line === '[' || line === 'state {') {
            // open composite
            const last = Array.from(nodes.keys()).pop() ?? `g_${stack.length}`;
            stack.push(`g_${last}`);
            continue;
        }
        if (line === ']' || line === '}') {
            stack.pop();
            continue;
        }
        const t = TRANSITION_RE.exec(line);
        if (t) {
            const [, from, to, label] = t;
            ensure(from, from);
            ensure(to, to);
            edges.push({
                id: `e_${edges.length}_${from}_${to}`,
                from: from,
                to: to,
                label: label?.trim() || undefined,
            });
        }
        else {
            // bare state declaration
            if (/^\[\*\]/.test(line))
                ensure('[*]', 'start', 'ellipse');
            else if (line)
                ensure(line, line);
        }
    }
    return {
        type: 'state',
        nodes: Array.from(nodes.values()),
        edges,
        groups: [],
        styles: {},
        meta: {},
    };
};
//# sourceMappingURL=state.js.map